export default "__VITE_ASSET__06ca65a3__"